export default "/_next/static/images/bc/fun-bcd393411b62726cf88d864620b8335c.jpg";